<div class="d-flex flex-column h-100">
    <div class="flex-grow-0">
        <app-headline></app-headline>
    </div>
    <div class="flex-grow-1 overflow-auto">
        <div *ngIf="i === serviceCount">
            <router-outlet></router-outlet>
        </div>
        <div *ngIf="i !== serviceCount" class="loadingGif">
            <app-loading-gif></app-loading-gif>
        </div>
    </div>
</div>

